<template>
  <section class="print-main">
    <!-- <a href="javascript:;" @click="setPrintHide()" class="iconfont icon-close"></a> -->
    <div class="print-btn no-print">
      <el-button @click="print()" class="" type="success" icon="el-icon-printer" size="small">立即打印</el-button>
      <el-button @click="setPrintHide()" size="small" type="info">取消打印</el-button>
    </div>

    <div class="print-body" id="printTable" ref="printTable">
      <material-in v-if="printData.type==='materialIn'" :materials="materials" :materialData="materialData">
      </material-in>
      <material-use v-if="printData.type==='materialUse'" :materials="materials" :materialData="materialData">
      </material-use>
      <material-back v-if="printData.type==='materialBack'" :materials="materials" :materialData="materialData">
      </material-back>
      <material-back-a v-if="printData.type==='materialBackA'" :materials="materials"
        :materialData="materialData">
      </material-back-a>
      <material-back-force v-if="printData.type==='materialBackForce'" :materials="materials"
        :materialData="materialData">
      </material-back-force>
      <material-out v-if="printData.type==='materialOut'" :materials="materials" :materialData="materialData">
      </material-out>
      <material-use-out v-if="printData.type==='materialUseOut'" :materials="materials" :materialData="materialData">
      </material-use-out>

    </div>
  </section>
</template>

<style lang="scss">
</style>
<script>
  import {
    mapState
  } from "vuex";

  import printJS from 'print-js'
  import materialIn from './materialIn'
  import materialUse from './materialUse'
  import materialBack from './materialBack'
  import materialBackA from './materialBackA'
  import materialBackForce from './materialBackForce'
  import materialOut from './materialOut'
  import materialUseOut from './materialUseOut'
  export default {
    components: {
      materialIn,
      materialUse,
      materialBack,
      materialBackA,
      materialOut,
      materialUseOut,
      materialBackForce,
    },
    computed: {
      ...mapState({
        printData: state => state.main.printData,
      })
    },
    data() {
      return {
        materialData: {},
        materials: []
      }
    },
    created() {
      this.materialData = this.printData.data
      // 循环处理数据
      let _materials = []
      switch (this.printData.type) {
        case 'materialIn':
        case 'materialBack':
        case 'materialBackA':
        case 'materialOut':
        case 'materialUseOut':
        case 'materialBackForce':
          _materials = this.materialData.materials
          break;
        case 'materialUse':
          _materials = this.materialData.materialUse
          break;
      }

      let page_count = 10;

      let _data_arr = []
      for (var i = 0; i < _materials.length; i++) {
        let _item = _materials[i]
        if (!_data_arr[Math.floor(i / page_count)]) {
          _data_arr[Math.floor(i / page_count)] = []
        }
        _data_arr[Math.floor(i / page_count)].push(_item)
      }
      this.materials = _data_arr //.slice(0, 4)
    },
    methods: {
      // 取消打印
      setPrintHide() {
        this.$store.commit('set_printData', {
          type: '',
          data: '',
          isPrint: false,
        })
      },
      // 打印
      print() {
        // printJS({
        //   printable: 'printTable',
        //   type: 'html',
        //   css: 'print.css', //引入css文件
        //   scanStyles: false
        // });
        this.$print(this.$refs.printTable)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/print/index.vue